import {InjectionToken} from '@angular/core';

export const W3_AUTH_SERVICE = new InjectionToken('W3_AUTH_SERVICE');
export const W3_PUBLIC_FALLBACK_PAGE_URI = new InjectionToken('W3_PUBLIC_FALLBACK_PAGE_URI');
export const W3_PROTECTED_FALLBACK_PAGE_URI = new InjectionToken('W3_PROTECTED_FALLBACK_PAGE_URI');
